(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Smart-Video-Format"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root=document.getElementById('smart-video-{{ section.id }}'); if(!root) return;
  const mode=root.getAttribute('data-mode');
  if(mode==='autoplay'){
    root.querySelectorAll('.svf-autoplay').forEach(v=>{
      v.muted=true; v.setAttribute('muted','');
      v.playsInline=true; v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
      v.autoplay=true; v.loop=true;
      const go=()=>{ try{ v.play(); }catch(e){} };
      v.addEventListener('loadedmetadata',go,{once:true}); go(); setTimeout(go,60); setTimeout(go,180);
    });
    return;
  }
})();

  } catch(e) { console.error(e); }
})();
})();
